var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "83px",
    height: "97px",
    viewBox: "0 0 83 97",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0.885115607%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "47.919324%",
    x2: "100%",
    y2: "47.919324%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "89.2024529%",
    y1: "83.7378561%",
    x2: "23.2628688%",
    y2: "4.632213%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "51.3373481%",
    y1: "83.7378561%",
    x2: "49.1065944%",
    y2: "5.28989558%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HH---Complete-the-assessments-and-reveal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Employer-Dashboard-LG-03.7.0-Copy-3",
    transform: "translate(-205.000000, -1464.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy-2",
    transform: "translate(62.000000, 1371.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(143.617435, 93.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.1669879,0.5 C81.448164,2.01768961 82.0670922,5.09727878 80.5494026,7.37845492 C80.1848539,7.92639291 79.7149259,8.39632086 79.1669879,8.76086957 L79.1669879,8.76086957 L79.1669879,8.76086957 L69.298845,91.4846013 C69.0255882,93.7752879 67.0829064,95.5 64.775979,95.5 L16.9891516,95.5 C14.6822242,95.5 12.7395425,93.7752879 12.4662857,91.4846013 L2.59814273,8.76086957 L2.59814273,8.76086957 C0.316966589,7.24317995 -0.30196153,4.16359079 1.21572808,1.88241465 C1.58027679,1.33447665 2.05020474,0.864548702 2.59814273,0.5 L2.59814273,0.5 L2.59814273,0.5 L79.1669879,0.5 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3825653,45.5 C42.3825653,42.387987 42.3825653,29.6061086 42.3825653,10 C42.3825653,-9.60610862 42.3825653,-23.5636364 42.3825653,-25.5 C41.2779958,-25.5 40.3825653,-9.60610862 40.3825653,10 C40.3825653,29.6061086 41.2779958,45.5 42.3825653,45.5 Z",
    id: "Oval",
    fill: "url(#linearGradient-2)",
    opacity: 0.100000001,
    transform: "translate(41.382565, 10.000000) rotate(-90.000000) translate(-41.382565, -10.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3825653,26.5 L64.3500559,89.9463007 C64.2520203,90.8307637 63.5045061,91.5 62.6146264,91.5 L19.1505042,91.5 C18.2606245,91.5 17.5131103,90.8307637 17.4150747,89.9463007 L10.3825653,26.5 L10.3825653,26.5 L71.3825653,26.5 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F8F8F8",
    cx: 52.8825653,
    cy: 83,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F8F8F8",
    cx: 37.8825653,
    cy: 77,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F8F8F8",
    cx: 21.8825653,
    cy: 42,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F8F8F8",
    cx: 28.8825653,
    cy: 31,
    r: 1.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "url(#linearGradient-4)",
    points: "25.3825653 12.5 12.3825653 12.5 23.6121192 87.5"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterIcon);
export default __webpack_public_path__ + "static/media/water-icon.caf08077fa955a73867ba5cf746d889d.svg";
export { ForwardRef as ReactComponent };